'use strict';

(function ($, Drupal) {
  Drupal.behaviors.Carousel = {
    attach: function attach() {
      /* Client CAROUSEL */
      function clientCarousel() {
        var carousalCount3Block = 1;
        var carousalNextCount3Block = 2;
        var clientTotalCount = $('.visible-section .block').length + 1;
        var carousalNextTwoCount = 3;
        var visibleSection = $('.visible-section');
        $('.prev-next-controls .prev').click(function () {
          visibleSection.children(".block:nth-child(".concat(carousalCount3Block, ")")).removeClass('active');
          visibleSection.children(".block:nth-child(".concat(carousalNextCount3Block, ")")).removeClass('active');
          visibleSection.children(".block:nth-child(".concat(carousalNextTwoCount, ")")).removeClass('active');
          if (carousalCount3Block > 1) {
            carousalCount3Block -= 1;
            $('.visible-section').children(".block:nth-child(".concat(carousalCount3Block, ")")).addClass('active');
          } else {
            carousalCount3Block = clientTotalCount - 1;
            visibleSection.children(".block:nth-child(".concat(carousalCount3Block, ")")).addClass('active');
          }
          if (carousalNextCount3Block > 1) {
            carousalNextCount3Block -= 1;
            $('.next-one-section').children(".block:nth-child(".concat(carousalNextCount3Block, ")")).addClass('active');
          } else {
            carousalNextCount3Block = clientTotalCount - 1;
            $('.next-one-section').children(".block:nth-child(".concat(carousalNextCount3Block, ")")).addClass('active');
          }
          if (carousalNextTwoCount > 1) {
            carousalNextTwoCount -= 1;
            $('.next-two-section').children(".block:nth-child(".concat(carousalNextTwoCount, ")")).addClass('active');
          } else {
            carousalNextTwoCount = clientTotalCount - 1;
            $('.next-two-section').children(".block:nth-child(".concat(carousalNextTwoCount, ")")).addClass('active');
          }
        });
        $('.prev-next-controls .next').click(function () {
          visibleSection.children(".block:nth-child(".concat(carousalCount3Block, ")")).removeClass('active');
          $('.next-one-section').children(".block:nth-child(".concat(carousalNextCount3Block, ")")).removeClass('active');
          $('.next-two-section').children(".block:nth-child(".concat(carousalNextTwoCount, ")")).removeClass('active');
          carousalCount3Block += 1;
          carousalNextCount3Block += 1;
          carousalNextTwoCount += 1;
          if (carousalCount3Block < clientTotalCount) {
            visibleSection.children(".block:nth-child(".concat(carousalCount3Block, ")")).addClass('active');
          } else {
            carousalCount3Block = 1;
            visibleSection.children(".block:nth-child(".concat(carousalCount3Block, ")")).addClass('active');
          }
          if (carousalNextCount3Block < clientTotalCount) {
            $('.next-one-section').children(".block:nth-child(".concat(carousalNextCount3Block, ")")).addClass('active');
          } else {
            carousalNextCount3Block = 1;
            $('.next-one-section').children(".block:nth-child(".concat(carousalNextCount3Block, ")")).addClass('active');
          }
          if (carousalNextTwoCount < clientTotalCount) {
            $('.next-two-section').children(".block:nth-child(".concat(carousalNextTwoCount, ")")).addClass('active');
          } else {
            carousalNextTwoCount = 1;
            $('.next-two-section').children(".block:nth-child(".concat(carousalNextTwoCount, ")")).addClass('active');
          }
        });
      }
      clientCarousel();

      /* Three Block Image
      NEED MORE DESCRIPTION FOR THIS FUNCTION */
      $('.half-heading-half-carousal .visible-section').children('.block:nth-child(1)').addClass('active');
      $('.half-heading-half-carousal .next-one-section').children('.block:nth-child(2)').addClass('active');
      $('.half-heading-half-carousal .next-two-section').children('.block:nth-child(3)').addClass('active');
      /* CAROUSEL
      careers page */
      $('.carousel-half-and-half-descriptive-block').owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        mouseDrag: false,
        touchDrag: false,
        dots: false,
        autoplay: false,
        autoplayTimeout: 5000,
        autoHeight: true,
        items: 1
      });
      /* Team page */
      var $teamCarousel = $('.teamPopupCarousel').owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        mouseDrag: false,
        touchDrag: false,
        dots: false,
        autoplay: false,
        autoplayTimeout: 5000,
        autoHeight: true,
        items: 1,
        URLhashListener: true,
        startPosition: 'URLHash'
      });
      /* TEAM WORKING */
      $('.close-popup').click(function () {
        $('.team-popup').hide();
        $('.team-popup-top').hide();
      });
      /* CLICK */
      $('.team-section').children('.contentWrapper-1290').children('ul').children('li').click(function (event) {
        event.preventDefault();
        var childIndex = $(this).index();
        if ($(window).width() < 481) {
          if ($(this).children('.content').children('p').css('display') === 'none') {
            $('.team-section').children('.contentWrapper-1290').children('ul').children('li').children('.content').children('p').hide();
            $(this).children('.content').children('p').slideDown();
            $(this).children('.content').children('.team-mobile-close-btn').show();
            $('html, body').stop().animate({
              scrollTop: $(this).children('.content').offset().top
            }, 1000, 'linear');
          }
        } else {
          $('.team-popup').show();
        }
        $teamCarousel.trigger('refresh.owl.carousel');
        $teamCarousel.trigger('to.owl.carousel', childIndex);
      });
      $('.team-mobile-close-btn').click(function (event) {
        event.preventDefault();
        $(this).parent('.content').children('p').slideUp();
        $(this).hide();
        $('html, body').stop().animate({
          scrollTop: $(this).parent('.content').parent('li').offset().top - 150
        }, 1000, 'linear');
      });
      /* SLIDER for the social */
      var carouselSection = $('.carousel-section');
      carouselSection.find('.first-images').each(function () {
        var src = $(this).find('article').find('img').attr('src');
        $('.first-image-box').find('.image-wrapper').append("<img src=\"".concat(src, "\" alt=\"\" />"));
      });
      carouselSection.find('.second-images').each(function () {
        var src = $(this).find('article').find('img').attr('src');
        $('.second-image-box').find('.image-wrapper').append("<img src=\"".concat(src, "\" alt=\"\" />"));
      });
      carouselSection.find('.third-images').each(function () {
        var src = $(this).find('article').find('img').attr('src');
        $('.third-image-box').find('.image-wrapper').append("<img src=\"".concat(src, "\" alt=\"\" />"));
      });
      var firstCount = 0;
      $('.first-image-box').find('.image-wrapper').find('img').each(function () {
        $(this).css('transform', "translate(-".concat(firstCount, "00%, 0%) matrix(1, 0, 0, 1, 0, 0)"));
        firstCount += 1;
        if (firstCount === 1) {
          $('.carousel-social-nav').append("<li class=\"active socail-nav-li\" id=\"socail-nav-li".concat(firstCount, "\" ></li>"));
        } else {
          $('.carousel-social-nav').append("<li class=\"socail-nav-li\" id=\"socail-nav-li".concat(firstCount, "\"></li>"));
        }
      });

      /* SLIDER for the social */
      $('.socail-nav-li').click(function () {
        var id = $(this).attr('id').replace('socail-nav-li', '');
        $('.socail-nav-li').removeClass('active');
        $(this).addClass('active');
        $('.first-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(-100%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.second-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(-100%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.third-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(-100%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.first-image-box').children('.image-wrapper').children("img:nth-child(".concat(id, ")")).css('transform', 'translate(0%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.second-image-box').children('.image-wrapper').children("img:nth-child(".concat(id, ")")).css('transform', 'translate(0%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.third-image-box').children('.image-wrapper').children("img:nth-child(".concat(id, ")")).css('transform', 'translate(0%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        socialCount = parseInt(id);
      });
      var secondCount = 0;
      $('.second-image-box').children('.image-wrapper').children('img').each(function () {
        $(this).css('transform', "translate(-".concat(secondCount, "00%, 0%) matrix(1, 0, 0, 1, 0, 0)"));
        secondCount += 1;
      });
      var thirdCount = 0;
      $('.third-image-box').children('.image-wrapper').children('img').each(function () {
        $(this).css('transform', "translate(-".concat(thirdCount, "00%, 0%) matrix(1, 0, 0, 1, 0, 0)"));
        thirdCount += 1;
      });
      var socialCount = 1;
      $('.social-next').click(function () {
        $('.first-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(-100%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.second-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(-100%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.third-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(-100%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        if (firstCount === socialCount) {
          socialCount = 1;
        } else {
          socialCount += 1;
        }
        $('.first-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(0%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.second-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(0%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.third-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(0%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.socail-nav-li').removeClass('active');
        $("#socail-nav-li".concat(socialCount)).addClass('active');
      });
      var socialCount = 1;
      $('.social-prev').click(function () {
        $('.first-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(-100%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.second-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(-100%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.third-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(-100%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        if (socialCount === 1) {
          socialCount = firstCount;
        } else {
          socialCount -= 1;
        }
        $('.first-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(0%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.second-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(0%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.third-image-box').children('.image-wrapper').children("img:nth-child(".concat(socialCount, ")")).css('transform', 'translate(0%, 0%) matrix(1, 0, 0, 1, 0, 0)');
        $('.socail-nav-li').removeClass('active');
        $("#socail-nav-li".concat(socialCount)).addClass('active');
      });
    }
  };
})(jQuery, Drupal);